import { takeLatest } from 'redux-saga/effects';
import { AUTH_CHECK, REFRESH_AUTH } from '../../actions/auth';
import getAuthCheckSaga, { getRefeshAuthSaga } from './auth';

function* watchSagas() {
  yield takeLatest(AUTH_CHECK.INITIATE, getAuthCheckSaga);
  yield takeLatest(REFRESH_AUTH.INITIATE, getRefeshAuthSaga);
}

export default watchSagas;
